// extracted by mini-css-extract-plugin
export default {"avatar":"account_avatar__b6nsH"};